import { cx } from '@/lib/cx';

/** The MyDash mark (brand/mark.svg): ink tile, yellow rising line ending in a dot. */
export function Mark({ className, title }: { className?: string; title?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={cx('shrink-0', className)} role={title ? 'img' : undefined} aria-label={title} aria-hidden={title ? undefined : true}>
      <rect width="64" height="64" rx="15" className="fill-[#1C1B17] dark:fill-[#F5C21B]" />
      <path
        d="M13 42 L25 31 L33 37 L46 23"
        fill="none"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-[#F5C21B] dark:stroke-[#1C1B17]"
      />
      <circle cx="50" cy="19" r="5" className="fill-[#F5C21B] dark:fill-[#1C1B17]" />
    </svg>
  );
}

/** Mark + wordmark. On dark grounds the tile turns yellow with an ink line (logo-reverse.svg). */
export function Logo({ className }: { className?: string }) {
  return (
    <span className={cx('inline-flex items-center gap-2.5', className)}>
      <Mark className="h-full w-auto" />
      <span className="relative text-[1.35em] leading-none font-bold tracking-[-0.035em] text-ink">
        MyDash
        <span aria-hidden className="absolute -bottom-[0.22em] left-[42%] h-[0.14em] w-[58%] rounded-full bg-yellow" />
      </span>
    </span>
  );
}
